import { useModeAwareQuery } from "./useModeAwareQuery";
import { useApi } from "./useApi";

export interface GeneralSettings {
  onStopNotesEnabled: boolean;
  categoryKeys: {
    userSortKey1Label: string;
    userSortKey2Label: string;
    userSortKey3Label: string;
    userSortKey4Label: string;
  };
}

const DEFAULT_SETTINGS: GeneralSettings = {
  onStopNotesEnabled: false,
  categoryKeys: {
    userSortKey1Label: 'User Sort Key 1',
    userSortKey2Label: 'User Sort Key 2',
    userSortKey3Label: 'User Sort Key 3',
    userSortKey4Label: 'User Sort Key 4',
  },
};

/**
 * Hook to fetch general settings
 * Handles both Demo and Live modes
 */
export function useGeneralSettings() {
  const { apiGet } = useApi();

  return useModeAwareQuery<GeneralSettings, Error>(
    ["general-settings"],
    async ({ signal }) => {
      const response = await apiGet<GeneralSettings>(
        `/api/v1/settings/general`,
        undefined,
        signal
      );
      return response;
    },
    DEFAULT_SETTINGS,
    {
      staleTime: 5 * 60 * 1000, // Cache for 5 minutes
    }
  );
}
